module.exports = __webpack_public_path__ + "media/dashboard/assets/icons/ic_lock-2ee26b56da01a7785cdbea0d16fc6904.svg";